<div [ngClass]="'spinner-'+spinnerType"  [style.width]="spinnerWidth+'px'" [style.height]="spinnerWidth+'px'"  role="status">
  <span class="visually-hidden">Loading...</span>
</div>
